import { render, staticRenderFns } from "./OscillographyChartLegends.vue?vue&type=template&id=a51071f6&scoped=true&"
import script from "./OscillographyChartLegends.vue?vue&type=script&lang=js&"
export * from "./OscillographyChartLegends.vue?vue&type=script&lang=js&"
import style0 from "./OscillographyChartLegends.vue?vue&type=style&index=0&id=a51071f6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a51071f6",
  null
  
)

export default component.exports